// extracted by mini-css-extract-plugin
export default {"root":"BasicInput_root__kveiZ"};